/* Click-to-toggle video with a custom overlay (Claude Design Handoff
   "Benefits Element mit Video", Benefits Section.dc.html). No autoplay: the
   overlay stays visible until the visitor clicks play, matching the mockup's
   React state (showOverlay = !playing). No native controls at any point —
   clicking the video area itself toggles play/pause and the overlay
   reappears on pause, so there's no ambiguity with a native control bar. */
(function () {
  function initFrame(frame) {
    if (frame.dataset.bvInit) return;
    frame.dataset.bvInit = 'true';

    var video = frame.querySelector('[data-benefits-video]');
    var playBtn = frame.querySelector('[data-benefits-play]');
    var progress = frame.querySelector('[data-benefits-progress]');
    var progressFill = frame.querySelector('[data-benefits-progress-fill]');
    if (!video || !playBtn) return;

    function toggle() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    playBtn.addEventListener('click', toggle);
    video.addEventListener('click', toggle);

    video.addEventListener('play', function () {
      frame.classList.add('is-playing');
    });
    video.addEventListener('pause', function () {
      frame.classList.remove('is-playing');
    });

    if (progress && progressFill) {
      video.addEventListener('timeupdate', function () {
        if (!video.duration) return;
        progressFill.style.width = (video.currentTime / video.duration) * 100 + '%';
      });

      progress.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!video.duration) return;
        var rect = progress.getBoundingClientRect();
        var ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
        video.currentTime = ratio * video.duration;
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-benefits-video-frame]').forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
